/* TOKYO LILY — 共通カルーセル (tl-carousel.js)
   [data-tl-carousel] を初期化する。TOPの「商品ランキング」「出演タレント」で共有。

   - 1回の送り幅 = 表示枚数ぶん（＝ビューポート1画面）。表示枚数は CSS 変数 --tlcar-per
     （PC4 / タブレット3 / スマホ2）から読むため、CSS 側だけで枚数を変えられる。
   - スクロール位置から現在ページを求め、ドットと矢印の活性/非活性を同期する。
   - スワイプはブラウザ標準の慣性スクロール＋scroll-snap に任せる（自前実装しない）。
   - カードを後から差し替える場合は car.tlCarouselRefresh() を呼ぶ（枚数・ドットを測り直す）。
*/
(function () {
  'use strict';

  function perView(root, track) {
    var v = parseFloat(getComputedStyle(root).getPropertyValue('--tlcar-per'));
    if (v > 0) return Math.round(v);
    /* CSS 変数が取れない場合はセル幅から逆算 */
    var step = cellStep(track);
    var vp = track.parentElement;
    return step > 0 ? Math.max(1, Math.round(vp.clientWidth / step)) : 1;
  }

  /* セル1枚ぶんの移動量（カード幅 + gap） */
  function cellStep(track) {
    var cells = track.children;
    if (cells.length < 2) return cells.length ? cells[0].getBoundingClientRect().width : 0;
    return cells[1].getBoundingClientRect().left - cells[0].getBoundingClientRect().left;
  }

  function initCarousel(car) {
    if (car.dataset.tlCarInit === '1') return;
    var vp = car.querySelector('.tlcar-vp');
    var track = car.querySelector('.tlcar-track');
    if (!vp || !track || !track.children.length) return;
    car.dataset.tlCarInit = '1';

    var prev = car.querySelector('.tlcar-prev');
    var next = car.querySelector('.tlcar-next');
    var dotsWrap = car.querySelector('.tlcar-dots');
    var total = track.children.length;
    var per = 1;
    var pages = 1;
    var current = 0;

    function pageWidth() {
      var step = cellStep(track);
      return step > 0 ? step * per : vp.clientWidth;
    }

    function maxScroll() {
      return Math.max(0, vp.scrollWidth - vp.clientWidth);
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tlcar-dot' + (i === current ? ' on' : '');
        b.setAttribute('aria-label', (i + 1) + 'ページ目へ');
        b.dataset.page = String(i);
        dotsWrap.appendChild(b);
      }
    }

    function goPage(n) {
      var target = Math.min(Math.max(n, 0), pages - 1) * pageWidth();
      vp.scrollLeft = Math.min(target, maxScroll());
    }

    /* スクロール位置 → 現在ページ・ボタン状態の同期 */
    function sync() {
      var w = pageWidth();
      current = w > 0 ? Math.round(vp.scrollLeft / w) : 0;
      current = Math.min(Math.max(current, 0), pages - 1);

      var atStart = vp.scrollLeft <= 1;
      var atEnd = vp.scrollLeft >= maxScroll() - 1;
      /* 件数が表示枚数で割り切れない場合、最終ページのスクロール量は
         1ページぶんに満たない。右端まで来ていれば最終ページ扱いにする */
      if (atEnd) current = pages - 1;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (dotsWrap) {
        var dots = dotsWrap.children;
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('on', i === current);
        }
      }
    }

    /* 表示枚数（＝ページ数）を測り直す。初期化時とリサイズ時に呼ぶ */
    function measure() {
      per = perView(car, track);
      var newPages = Math.max(1, Math.ceil(total / per));
      var isStatic = maxScroll() <= 1;
      car.classList.toggle('is-static', isStatic);
      if (newPages !== pages) {
        pages = newPages;
        buildDots();
      }
      sync();
    }

    if (prev) prev.addEventListener('click', function () { goPage(current - 1); });
    if (next) next.addEventListener('click', function () { goPage(current + 1); });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var b = e.target.closest('.tlcar-dot');
        if (b) goPage(parseInt(b.dataset.page, 10) || 0);
      });
    }

    /* スクロール中は頻繁に発火するので rAF で間引く */
    var ticking = false;
    vp.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });

    /* キーボード操作（矢印キー） */
    vp.setAttribute('tabindex', '0');
    vp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goPage(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goPage(current - 1); }
    });

    pages = Math.max(1, Math.ceil(total / perView(car, track)));
    buildDots();
    measure();

    /* カードを差し替えたあとに枚数を測り直すための入口。
       TOP の「出演タレント」がランキングを取得してカードを入れ替えたときに呼ぶ。
       初期化をやり直すとイベントが二重登録になるため、再初期化はしない。 */
    car.tlCarouselRefresh = function () {
      total = track.children.length;
      if (!total) return;
      vp.scrollLeft = 0;
      pages = Math.max(1, Math.ceil(total / perView(car, track)));
      buildDots();
      measure();
    };

    /* 画像の読み込み完了でカード高さが変わるとページ幅も変わるため測り直す */
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { measure(); });
      ro.observe(vp);
    } else {
      window.addEventListener('resize', measure);
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-tl-carousel]');
    if (!list.length && scope !== document) list = document.querySelectorAll('[data-tl-carousel]');
    Array.prototype.forEach.call(list, initCarousel);
  }

  /* 非同期でカードを差し込んだ後に初期化するための入口（タレント詳細の出演作品など） */
  window.tlCarouselInit = function (root) { initAll(root || document); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* テーマエディタでのセクション再描画に追随 */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
